
























import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import DatePicker from "@/scaffold/GridDatePicker.ts";

@Component({})
export default class TabularDataGrid extends Vue {
  debug() {
    console.log("debug");
  }
}
